var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3391_8973",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3333,
    y: 0.5,
    width: 17,
    height: 17,
    transform: "rotate(90 17.3333 0.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3391_8973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6831 8.99974L11.9206 6.23724C11.7908 6.10738 11.7258 5.9421 11.7258 5.74141C11.7258 5.54071 11.7908 5.37543 11.9206 5.24557C12.0505 5.11571 12.2158 5.05078 12.4165 5.05078C12.6171 5.05078 12.7824 5.11571 12.9123 5.24557L16.1706 8.50391C16.3123 8.64557 16.3831 8.81085 16.3831 8.99974C16.3831 9.18863 16.3123 9.35391 16.1706 9.49557L12.9123 12.7539C12.7824 12.8838 12.6171 12.9487 12.4165 12.9487C12.2158 12.9487 12.0505 12.8838 11.9206 12.7539C11.7908 12.624 11.7258 12.4588 11.7258 12.2581C11.7258 12.0574 11.7908 11.8921 11.9206 11.7622L14.6831 8.99974Z",
    fill: "#A5BAC5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.6b041ba5f448eb36000bebe2baf9e54f.svg";
export { ForwardRef as ReactComponent };